import { FormControl, FormLabel } from "@chakra-ui/react";
import AddComment from "../Generic/AddComment";

interface WorkoutCommentProps {
  commentIsInvalid: boolean;
  addComments: boolean;
  comment: string;
  showLabel?: boolean;
  setComment: (newComment: string) => void;
}

export default function WorkoutComment({
  commentIsInvalid,
  addComments,
  comment,
  showLabel,
  setComment,
}: WorkoutCommentProps) {
  return (
    <FormControl mt="0.5rem" isInvalid={commentIsInvalid}>
      {showLabel && (
        <FormLabel fontSize={["sm", "lg"]} mb="4px" alignSelf="flex-start">
          <b>Workout Comment</b>
        </FormLabel>
      )}
      {addComments && (
        <AddComment
          isInvalid={commentIsInvalid}
          placeholderText="Add a Workout Comment"
          comment={comment}
          setComment={setComment}
        />
      )}
    </FormControl>
  );
}
